import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody, Label } from "reactstrap";

import AgencyFilter from "./AgencyFilter";
import Flatpickr from "react-flatpickr";
import ContractTypeFilter from "./ContractTypeFilter";
const OffCanvasFilter = ({
  show,
  onCloseClick,
  setFilterValue,
  filterValue,
  setPage,
  setSearchValue,
  searchValue,
  clearFilters,
}: any) => {
  return (
    <Offcanvas
      direction="end"
      isOpen={show}
      id="offcanvasRight"
      toggle={onCloseClick}
    >
      <OffcanvasHeader className="bg-light" toggle={onCloseClick}>
        Contract Filters
      </OffcanvasHeader>
      <form
        action=""
        className="d-flex flex-column justify-content-end h-100"
        onSubmit={(e) => {
          e.preventDefault();
          onCloseClick();
        }}
      >
        <OffcanvasBody>
          <div className="mb-4">
            <Label
              htmlFor="datepicker-range"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Search
            </Label>
            {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
            <div className="search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search payments..."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(1);
                }}
                value={searchValue}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </div>
          {/* <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Status
            </Label>
            <select
              className="form-control"
              data-choices
              data-choices-search-false
              name="choices-single-default2"
              id="choices-single-default2"
              onChange={(e: any) => {
                setFilterValue({
                  ...filterValue,
                  status: e.target.value,
                });
                setPage(1);
              }}
              value={filterValue.status}
            >
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div> */}
          <div className="mb-4">
            <Label className="form-label text-muted text-uppercase fw-semibold mb-2">
              Contract Category
            </Label>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-all"
                checked={!filterValue?.isLOA && !filterValue?.isLTA}
                onChange={() => {
                  const { isLOA, isLTA, ...rest } = filterValue || {};
                  setFilterValue(rest);
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-all">
                All Contracts
              </Label>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-loa"
                checked={!!filterValue?.isLOA}
                onChange={() => {
                  setFilterValue({
                    ...filterValue,
                    isLOA: true,
                    isLTA: undefined,
                  });
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-loa">
                Letters of Agreement (LOAs)
              </Label>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="contract-kind"
                id="contract-kind-lta"
                checked={!!filterValue?.isLTA}
                onChange={() => {
                  setFilterValue({
                    ...filterValue,
                    isLTA: true,
                    isLOA: undefined,
                  });
                  setPage(1);
                }}
              />
              <Label className="form-check-label" htmlFor="contract-kind-lta">
                Long Term Agreements (LTAs)
              </Label>
            </div>
          </div>
          <div className="mb-4">
            <Label
              htmlFor="region-field"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              SelectContract Type
            </Label>
            <ContractTypeFilter
              onChange={(value) => {
                setFilterValue({ ...filterValue, contractType: value });
                setPage(1);
              }}
              value={filterValue.contractType}
            />
          </div>

          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Select Agency
            </Label>
            <AgencyFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, agency: value });
                setPage(1);
              }}
              value={filterValue.agency}
            />
          </div>
          <div className="mb-4">
            <Label
              htmlFor="status-select"
              className="form-label text-muted text-uppercase fw-semibold mb-2"
            >
              Select Date Range
            </Label>
            {/* @ts-ignore */}
            <Flatpickr
              className="form-control"
              placeholder="Select Date Range"
              options={{
                mode: "range",
                altFormat: "d M, Y",
                dateFormat: "d M, Y",
              }}
              onChange={(e) => {
                if (e[0] && e[1]) {
                  setFilterValue({
                    ...filterValue,
                    dateRange: {
                      fromDate: e[0],
                      toDate: e[1],
                    },
                  });
                  setPage(1);
                }
              }}
              value={[
                filterValue?.dateRange?.fromDate || "",
                filterValue?.dateRange?.toDate || "",
              ]}
            />
          </div>
        </OffcanvasBody>
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <button
            className="btn btn-light w-100"
            onClick={(e) => {
              e.preventDefault();
              clearFilters();
            }}
          >
            Clear Filter
          </button>
          <button
            type="submit"
            className="btn btn-success w-100"
            onClick={onCloseClick}
          >
            Submit
          </button>
        </div>
      </form>
    </Offcanvas>
  );
};

export default OffCanvasFilter;
